import Checkout from '../Checkout';
import Loading from '../../../../shared/Loading';
import React, { useEffect } from 'react';
import useAgentSubscriptionManagementLink from '../../../../Hooks/Agent/Getters/useAgentSubscriptionManagementLink/useAgentSubscriptionManagementLink';
import useGetAgentSubscription from '../../../../Hooks/Agent/Getters/useGetAgentSubscription/useGetAgentSubscription';

/** @returns {JSX.Element} */
export default function SubscriptionIndex() {
	const { isGettingData, data: subscription } = useGetAgentSubscription();
	const subManagementLink = useAgentSubscriptionManagementLink();

	useEffect(() => {
		if (subManagementLink.data) {
			window.location.href = subManagementLink.data;
		}
	}, [subManagementLink.data]);

	if (isGettingData || subscription?.isActive || subscription?.isRenewing) {
		return <Loading />;
	}

	return <Checkout />;
}
